import script from "./ListYourFranchise.vue?vue&type=script&setup=true&lang=js"
export * from "./ListYourFranchise.vue?vue&type=script&setup=true&lang=js"

import "./ListYourFranchise.vue?vue&type=style&index=0&id=de8ba590&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de8ba590"]])

export default __exports__